import { useMemo, useState } from 'react'

import { AccordionList, AccordionListContainer, AccordionListContent, AccordionListItem, AccordionListTrigger } from 'twyne-new.ui'

import { useGlobalAuthStore } from '@/stores/global/auth'

import AccordionContent from './BlockList'
import Filters from './Filters'
import { BlocksProvider } from './hooks'

export default function Blocks() {
  const [value, setValue] = useState('general')
  const { auth: { currentSession } } = useGlobalAuthStore()
  const userParams = useMemo(() => ({ userId: currentSession?.user?.id }), [currentSession])
  const organizationParams = useMemo(() => ({ level: 'organization' }), [])

  const handleValueChange = value => {
    setValue(value)
  }

  return <BlocksProvider>
    <AccordionListContainer >
      <Filters />
      <AccordionList type='single' defaultValue='general' onValueChange={handleValueChange}>
        <Block label='General' value='general' active={value === 'general'} />
        <Block label='Mine' value='mine' params={userParams} active={value === 'mine'} />
        <Block label='Organization' value='organization' params={organizationParams} active={value === 'organization'} />
      </AccordionList>
    </AccordionListContainer>
  </BlocksProvider>
}

function Block({ label, value, ...props }) {
  return <>
    <AccordionListItem value={value}>
      <AccordionListTrigger>{label}</AccordionListTrigger>
      <AccordionListContent className='twy-bg-base'>
        <AccordionContent value={value} {...props} />
      </AccordionListContent>
    </AccordionListItem>
  </>
}
